import {useTranslation} from "react-i18next";
import {AssignmentFailReason} from "../../schema";

type props = {
  reason: AssignmentFailReason;
};

function AssignModalFailReasonText({reason}: props) {
  const {t} = useTranslation();
  const assignFailReasonsText = {
    [AssignmentFailReason.INACTIVE_USER]: t("components.AssignModal.helpText.inactiveUser"),
    [AssignmentFailReason.ALREADY_ASSIGNED]: t("components.AssignModal.helpText.alreadyAssigned"),
    [AssignmentFailReason.PARTLY_ASSIGNED]: t("components.AssignModal.helpText.partlyAssigned"),
  };

  return <>{assignFailReasonsText[reason]}</>;
}

export default AssignModalFailReasonText;
